import React, { Component } from 'react'
import * as styles from './index.module.css'
import Link from '../Link'

export default class SimpleCallout extends Component {
  render() {
    var props = this.props
    var { ctaText, ctaUrl } = props

    var subtitleComps = props.subtitle && props.subtitle.subtitle.split('\n')

    var containerStyles = [styles.container, styles.border]
    if (subtitleComps && subtitleComps.length > 1) {
      if (subtitleComps[1] == 'no-border') {
        containerStyles = [styles.container]
      }
    }

    return (
      <div className="wrapper">
        <div className={containerStyles.join(' ')}>
          <h2>{props.title}</h2>
          <p>{subtitleComps && subtitleComps[0]}</p>
          <Link to={ctaUrl}>{ctaText}</Link>
        </div>
      </div>
    )
  }
}
